<app-navbar [menu]="menu" [logo]="logo" [site]="site"></app-navbar>
<router-outlet></router-outlet>
<app-footer [logo]="logofooter" [site]="site"></app-footer>
